import { __assign } from "tslib";
import { partial } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import getContext from 'recompose/getContext';
import { compose } from 'redux';
import { VelocityComponent } from 'velocity-react';
import { flashHotspots, hideOverlay, missedClick, unsetOverlayScrollPos, } from '../actionCreators';
import Overlay from '../components/Overlay';
import { OVERLAY_LAYER } from '../constants/userTest';
import onlyIf from '../hocs/onlyIf';
import { getOverlayAnnotations } from '../selectors/annotation';
import { isInHandoffMode } from '../selectors/handoff';
import { getScreenStyles } from '../selectors/layout';
import { getOverlayProps } from '../selectors/overlay';
import { getOverlayMissedClickPosition } from '../utils/tracking';
import { findClosestLayer, getEventMeta } from '../utils/userTest';
function mapStateToProps(state, _a) {
    var isCurrentScreen = _a.isCurrentScreen;
    var screenStyles = getScreenStyles(state, isCurrentScreen);
    return __assign(__assign({}, getOverlayProps(state, isCurrentScreen)), { annotations: getOverlayAnnotations(state), imageWidth: screenStyles.imageWidth, imageMargin: screenStyles.imageMargin, isOverlay: true, scrollTop: state.overlay.scrollPos, smoothScroll: state.overlay.smoothScroll, isHandoffMode: isInHandoffMode(state), isMobile: state.deviceDetection.isMobile, isIOS: state.deviceDetection.isIPad || state.deviceDetection.isIPhone, getMissedClickPosition: partial(getOverlayMissedClickPosition, state), getEventMeta: partial(getEventMeta, state) });
}
var Container = function (props) {
    if (props.id) {
        if (props.animation) {
            return (React.createElement(VelocityComponent, __assign({}, props.animation, { runOnMount: true }),
                React.createElement(Overlay, __assign({}, props))));
        }
        return React.createElement(Overlay, __assign({}, props));
    }
    return null;
};
Container.propTypes = {
    id: PropTypes.number,
    animation: PropTypes.object,
};
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var newProps = {
        onClick: function (clickArea, e) {
            dispatch(missedClick(stateProps.getMissedClickPosition(stateProps.id, clickArea, e)));
            dispatch(flashHotspots());
        },
        onBackgroundClick: function (e) {
            if (findClosestLayer(e.target, OVERLAY_LAYER))
                return;
            e.stopPropagation();
            dispatch(hideOverlay('', {
                miss: stateProps.getEventMeta(e),
            }));
        },
        onSetScrollEnd: function () {
            dispatch(unsetOverlayScrollPos());
        },
    };
    return __assign(__assign(__assign({}, ownProps), stateProps), newProps);
}
var isNotInHandoffMode = function (props) { return !props.isHandoffMode; };
export default compose(getContext({ isCurrentScreen: PropTypes.bool.isRequired }), connect(mapStateToProps, null, mergeProps), onlyIf(isNotInHandoffMode))(Container);
